/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import type { IProps } from './type';
import { defaultAgencyObj } from '../../../components/home/utils/helper';
import { RootState } from '../../../store/root-reducer';
import { getIsRequestSucceeded } from '../../utils';

const HelmetIcon: React.FC<IProps> = () => {
  const agencyConfig = useSelector(
    (state: RootState) => state.home.agencyConfig,
  );

  const getAgencyConfigRequest = useSelector(
    (state: RootState) => state.home.getAgencyConfigRequest,
  );

  if (!getIsRequestSucceeded(getAgencyConfigRequest.status)) {
    return null;
  }

  const faviconHref = agencyConfig?.favicon || defaultAgencyObj?.favicon;

  return (
    <Helmet>
      <link rel="icon" id="favicon" href={faviconHref} />
      <link
        rel="apple-touch-icon"
        type="image/png"
        href={faviconHref}
        sizes="180x180"
      />
      <link rel="icon" href={faviconHref} sizes="16x16" />
      <link rel="icon" href={faviconHref} sizes="32x32" />
      <link rel="icon" href={faviconHref} sizes="180x180" />
    </Helmet>
  );
};

export default HelmetIcon;
